import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import './SpecialFees.css';

const SpecialFees = () => {
  const [fees, setFees] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [brand, setBrand] = useState('');
  const [fee, setFee] = useState('');
  const [feeType, setFeeType] = useState('Porcentage');
  const [editingBrand, setEditingBrand] = useState(null);

  // Obtener el token de autenticación del almacenamiento local
  const getAuthToken = () => {
    return localStorage.getItem('admin_token');
  };

  useEffect(() => {
    fetchFees();
  }, []);

  const fetchFees = async () => {
    try {
      const token = getAuthToken();
      const res = await fetch('https://valleyapi-dr9y.onrender.com/api/special-fees', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!res.ok) {
        throw new Error(res.status === 401 ? 'Unauthorized' : 'Failed to fetch fees');
      }
      const data = await res.json();
      setFees(data);
    } catch (error) {
      console.error('Error fetching fees:', error);
      toast.error(error.message === 'Unauthorized' ? 'Please log in as admin' : 'Error fetching fees');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { brand, fee, fee_type: feeType };
    const token = getAuthToken();

    try {
      let res;
      if (editingBrand) {
        res = await fetch(`https://valleyapi-dr9y.onrender.com/api/special-fees/${editingBrand}`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
      } else {
        res = await fetch('https://valleyapi-dr9y.onrender.com/api/special-fees', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
      }

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || 'Failed to save fee');
      }

      toast.success(editingBrand ? 'Fee updated successfully' : 'Fee created successfully');
      setShowForm(false);
      setBrand('');
      setFee('');
      setFeeType('Porcentage');
      setEditingBrand(null);
      fetchFees();
    } catch (error) {
      console.error('Error submitting fee:', error);
      toast.error(error.message === 'Unauthorized' ? 'Please log in as admin' : error.message);
    }
  };

  const handleEdit = (fee) => {
    setBrand(fee.brand);
    setFee(fee.fee);
    setFeeType(fee.fee_type);
    setEditingBrand(fee.brand);
    setShowForm(true);
  };

  return (
    <div className="sf-container">
      <h1 className="sf-title">Special Fees</h1>
      <button
        className="sf-btn-primary"
        onClick={() => {
          setShowForm(true);
          setEditingBrand(null);
          setBrand('');
          setFee('');
          setFeeType('Porcentage');
        }}
      >
        Create New Fee
      </button>

      {fees.length === 0 ? (
        <p className="sf-no-data">None found!</p>
      ) : (
        <table className="sf-table">
          <thead>
            <tr className="sf-table-header">
              <th className="sf-table-cell">Brand</th>
              <th className="sf-table-cell">Fee</th>
              <th className="sf-table-cell">Fee Type</th>
              <th className="sf-table-cell">Actions</th>
            </tr>
          </thead>
          <tbody>
            {fees.map((f) => (
              <tr key={f.brand} className="sf-table-row">
                <td className="sf-table-cell">{f.brand}</td>
                <td className="sf-table-cell">{f.fee}</td>
                <td className="sf-table-cell">{f.fee_type}</td>
                <td className="sf-table-cell">
                  <button
                    className="sf-btn-edit"
                    onClick={() => handleEdit(f)}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showForm && (
        <div className="sf-form-container">
          <h2 className="sf-form-title">{editingBrand ? 'Edit Fee' : 'Add New Fee'}</h2>
          <form onSubmit={handleSubmit} className="sf-form">
            <div className="sf-form-group">
              <label className="sf-form-label">Brand</label>
              <input
                type="text"
                value={brand}
                onChange={(e) => setBrand(e.target.value)}
                placeholder="Enter brand"
                className="sf-form-input"
                required
                disabled={editingBrand}
              />
            </div>
            <div className="sf-form-group">
              <label className="sf-form-label">Fee</label>
              <input
                type="number"
                value={fee}
                onChange={(e) => setFee(e.target.value)}
                placeholder="Enter fee amount"
                className="sf-form-input"
                step="0.01"
                min="0"
                required
              />
            </div>
            <div className="sf-form-group">
              <label className="sf-form-label">Fee Type</label>
              <select
                value={feeType}
                onChange={(e) => setFeeType(e.target.value)}
                className="sf-form-select"
              >
                <option value="Porcentage">Porcentage</option>
                <option value="USD">USD</option>
              </select>
            </div>
            <div className="sf-form-actions">
              <button
                type="submit"
                className="sf-btn-submit"
              >
                {editingBrand ? 'Update' : 'Add'}
              </button>
              <button
                type="button"
                className="sf-btn-cancel"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default SpecialFees;